export class Stronicowanie {
    iloscRekordow?: number;
    rekordPoczatkowy?: number;
    pobierzWszystkieRekordy: boolean;
    strona: number;

    constructor(private pobierzWszystkie: boolean) {
        this.pobierzWszystkieRekordy = pobierzWszystkie;
    }
}